import { render, staticRenderFns } from "./Print_dorm.vue?vue&type=template&id=3178705a&scoped=true"
import script from "./Print_dorm.vue?vue&type=script&lang=js"
export * from "./Print_dorm.vue?vue&type=script&lang=js"
import style0 from "./Print_dorm.vue?vue&type=style&index=0&id=3178705a&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178705a",
  null
  
)

export default component.exports